goog.provide('el8.appchart.mgr.orderForm');

goog.require('el8.uiwidget.alert');
goog.require('el8.service.urls');
goog.require('el8.util.localStorage');


el8.appchart.mgr.orderForm = (function() {

    var onHoldMgr = null;
    var orderForms = null;
    var navtriggers = null;

    var labOrderForm = null;
    var imagingOrderForm = null;
    var cardiacOrderForm = null;
    var sleepOrderForm = null;
    var pulmonaryOrderForm = null;

    /**
     * Note: The Prescription order form is only rendered via React now.
     * See the showOrderForm() function for dispatch event.
     */
    var getFormMap = {
        "LabOrder" : function() {
            if( !labOrderForm ) {
                labOrderForm = orderForms.lab;
            }
            return labOrderForm;
        },
        "ImagingOrder" : function() {
            if( !imagingOrderForm ) {
                $('#new-imaging-order-dialog').el8_load(el8.service.urls.get('renderOrderForm', ['imaging']));
                imagingOrderForm = orderForms.imaging();
            }
            return imagingOrderForm;
        },
        "CardiacOrder" : function() {
            if( !cardiacOrderForm ) {
                $('#new-cardiac-order-dialog').el8_load(el8.service.urls.get('renderOrderForm', ['cardiac']));
                cardiacOrderForm = orderForms.cardiac();
            }
            return cardiacOrderForm;
        },
        "SleepOrder" : function() {
            if( !sleepOrderForm ) {
                $('#new-sleep-order-dialog').el8_load(el8.service.urls.get('renderOrderForm', ['sleep']));
                sleepOrderForm = orderForms.sleep();
            }
            return sleepOrderForm;
        },
        "PulmonaryOrder" : function() {
            if( !pulmonaryOrderForm ) {
                $('#new-pulmonary-order-dialog').el8_load(el8.service.urls.get('renderOrderForm', ['pulmonary']));
                pulmonaryOrderForm = orderForms.pulmonary();
            }
            return pulmonaryOrderForm;
        },
    };

    var showFormMap = {
        "LabOrder" : showLabOrderForm,
        "ImagingOrder" : showImagingOrderForm,
        "CardiacOrder" : showCardiacOrderForm,
        "SleepOrder" : showSleepOrderForm,
        "PulmonaryOrder" : showPulmonaryOrderForm,
        "ReferralOrder" : showReferralOrderForm
    };

    var isOnHoldMap = {
        "LabOrder" : false,
        "ImagingOrder" : false,
        "CardiacOrder" : false,
        "SleepOrder" : false,
        "PulmonaryOrder" : false,
        "ReferralOrder" : false,
        "MedOrder-prescription" : false,
        "MedOrder-controlled" : false,
        "MedOrder-otc" : false
    };

    function showOrderForm( modelClass, setLastPosition, spec, formType ) {
        if (modelClass === 'MedOrder-undeterminable') {
            modelClass = 'MedOrder-prescription';
        } else if (modelClass === 'MedOrder' || modelClass === 'MedOrder-samples') {
            // Basically if we got here, it means "we don't know what the type is,
            // try to figure it out from the medication in the order"
            if (spec && spec.model) {
                var printType = spec.model.getPrintType();

                if (printType && printType !== 'samples') {
                    if (printType === 'undeterminable' || printType === 'unknown') {
                      modelClass = 'MedOrder-prescription';
                    } else {
                      modelClass = 'MedOrder-' + printType;
                    }
                } else {
                    var modifier = 'prescription';
                    var medication = spec.model.getMedication();
                    if (medication) {
                        if (medication.isControlled()) { modifier = 'controlled'; }
                        else if (medication.isPrescription()) { modifier = 'prescription'; }
                        else if (medication.isOtc()) { modifier = 'otc'; }
                    }
                    modelClass = modelClass + '-' + modifier;
                }
            } else {
                modelClass = "MedOrder-prescription";
            }
        }
        if (modelClass === 'ReferralOrder') {
            showReferralOrderForm();
            return;
        }
        if (modelClass === "MedOrder-prescription" || modelClass === "MedOrder-otc" || modelClass === "MedOrder-controlled") {
          var openParams = {};
          if (spec) {
            if (spec.type) {
              openParams.type = spec.type;
            }
            if (spec.linkedThreadId) {
                openParams.linkedThreadId = spec.linkedThreadId;
            }
            if (spec.deniedRefillReq) {
              openParams.refillRequestId = spec.deniedRefillReq.getId();
              openParams.pharmacyNcpdpid = spec.deniedRefillReq._pharmacyNcpdpid;
              if (el8Globals.FEATURES.SCRIPTv2017071) {
                  openParams.refills = spec.deniedRefillReq._dispensedMedication._requestedRefills;
              }
            }
            if (spec.denialNote) {
              openParams.denialNote = spec.denialNote;
            }

            var latestPharmacyNcpdpid = null;
            if (spec.model) {
              openParams.prescriptionId = spec.model.getId();
              latestPharmacyNcpdpid = spec.model.getLatestPharmacyNcpdpid();
            } else if (spec.order) {
              openParams.prescriptionId = spec.order.getId();
              latestPharmacyNcpdpid = spec.order.getLatestPharmacyNcpdpid();
            }
            var latestPharmacy = el8.data.pharmacies.getByKey(latestPharmacyNcpdpid);
            if (latestPharmacy) {
              openParams.pharmacyNcpdpid = latestPharmacyNcpdpid;
              openParams.isPharmacyActive = latestPharmacy.rawData.is_active;
            }

            if (spec.onSaveCallback) {
                openParams.onSaveCallback = spec.onSaveCallback;
            }
            if (spec.onDeleteCallback) {
                openParams.onDeleteCallback = spec.onDeleteCallback;
            }
          }
          el8React.dispatch.openPrescriptionForm(openParams);
          return;
        }

        var dialog = getFormMap[ modelClass ]();
        dialog.show( setLastPosition, spec, formType );

        if( isOnHoldMap[ modelClass ] ) {
            onHoldMgr.removeItem( isOnHoldMap[ modelClass ] );
        }
        isOnHoldMap[ modelClass ] = false;

        return dialog;
    }

    function reOrderItem( order ) {
        var clonedOrder = $.extend(true, {}, order); // deep copy of object
        clonedOrder.setId(null); // we want to use the existing order just as a template
        clonedOrder.setSignDate(null);

        var showOrderFn = 'show' + order.getOrderType().capitalize() + 'OrderForm';
        el8.appchart.mgr.orderForm[showOrderFn](false, { model: clonedOrder });
    }

    function showReferralOrderForm( setLastPosition, spec ) {
        el8.appchart.mgr.thirdpane.showLetter({type: el8.util.consts.REFERRAL_LETTER});
    }

    function showLabOrderForm( setLastPosition, spec ) {
        showOrderForm( 'LabOrder', setLastPosition, spec );
    }

    function showImagingOrderForm( setLastPosition, spec ) {
        showOrderForm( 'ImagingOrder', setLastPosition, spec );
    }

    function showCardiacOrderForm( setLastPosition, spec ) {
        showOrderForm( 'CardiacOrder', setLastPosition, spec );
    }

    function showSleepOrderForm( setLastPosition, spec ) {
        showOrderForm( 'SleepOrder', setLastPosition, spec );
    }

    function showPulmonaryOrderForm( setLastPosition, spec ) {
        showOrderForm( 'PulmonaryOrder', setLastPosition, spec );
    }

    function showMedsOrderForm( setLastPosition, spec, formType ) {
        formType = formType || 'prescription';
        showOrderForm( 'MedOrder-'+formType, setLastPosition, spec);
    }

    function renderOnHoldOrder( order ) {
        // Can only add one on hold order per model class
        var modelClass = order.getModelClass();
        if (order.is('MedOrder')) {
            modelClass = order.getModelClass()+'-'+order.getPrintType();
        }
        if( !isOnHoldMap[modelClass] ) {
            isOnHoldMap[modelClass] = order;
            onHoldMgr.addItem( order, function() {
                isOnHoldMap[modelClass] = false;
                if (order.is('MedOrder')) {
                    showMedsOrderForm(true, null, order.getPrintType());
                } else {
                    showFormMap[modelClass](true, {model: order});
                }
            });
        }
    }

    // --------------------
    // Specific order form functionality
    // --------------------
    function getPrintFormType(order) {

        // Encapsulates logic for determining print form type from an order
        var medication = order.getMedication();
        if (medication && medication.isControlled()) {
            return 'controlled';
        }
        if (order.getPrintType() === 'samples') { return (medication && medication.isOtc() ? 'otc' : 'prescription'); }
        if (order.getPrintType()) { return order.getPrintType(); }

        if (!medication) {
            return order.isPrescription() ? 'prescription' : 'otc';
        } else if (medication.isOtc()) {
            return 'otc';
        } else if (medication.isPrescription()) {
            return 'prescription';
        } else {
            return order.isPrescription() ? 'prescription' : 'otc';
        }
    }

    function denyWithNewMedOrder(rxRefillReq, note) {
        var formType = rxRefillReq.isRequestForControlledMed() ? 'controlled' : 'prescription';
        showMedsOrderForm(false, {
            deniedRefillReq: rxRefillReq,
            denialNote: note
        }, formType);
    }

    function denyWithRefillMedOrder(rxRefillReq, note) {
        var formType = rxRefillReq.isRequestForControlledMed() ? 'controlled' : 'prescription';
        var originalMedOrder = rxRefillReq.getOriginalMedOrder();
        showMedsOrderForm(false, {
            deniedRefillReq: rxRefillReq,
            denialNote: note,
            type: 'Refill',
            linkedThreadId: (originalMedOrder && originalMedOrder.getThreadId()) || null
        }, formType);
    }

    function refillMedOrder(order) {
        showMedsOrderForm( false, {
            type: 'Refill',
            order: order
        }, getPrintFormType(order));
    }

    function bulkRefillMedOrders(orders) {
        var ordersToRefill = orders;
        ordersToRefill.forEach(function(order) {
            refillMedOrder(order)
        })
    }

    /**
     * Opens one or more draft medOrders into the Prescription Form
     * 
     * @param {object} targetDraftMedOrder a draft medOrder (e.g. from the requiring action queue)
     * NOTE: Since the targetDraftMedOrder is the medOrder the user interacted with, it is added
     * to the end of the list of draft medOrders to ensure that it's the selected medOrder in the
     * prescription form's queue.
     */
    function openDraftMedOrders(targetDraftMedOrder) {
      var draftMedOrders = el8.ptdata.medOrders.all().filter(function draftMedOrderFilter(medOrder) {
        return !medOrder.isSignedOff() 
          && medOrder.getPatientId() === el8.ptdata.currPatient.getId()
          && targetDraftMedOrder.getId() !== medOrder.getId();
      });
      draftMedOrders.push(targetDraftMedOrder);

      draftMedOrders.forEach(function(medOrder) {
        showOrderForm('MedOrder', false, { model: medOrder });
      });
    }

    function changeMedOrder(order) {
        showMedsOrderForm( false, {
            type: 'DoseChange',
            order: order
        }, getPrintFormType(order));
    }

    function reOrderMedOrder(order) {
        showMedsOrderForm( false, {
            type: 'New',
            order: order
        }, getPrintFormType(order));
    }

    // Different from the others since this is being called with an order set
    function reOrderFromRxOrderSet(orderSet) {
        el8React.dispatch.openPrescriptionForm({ type: 'New', templateId: orderSet.getId() });
    }

    function sendLabOrderToLab(labOrder, successCb) {
       $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('sendLabOrderToLab', [labOrder]),
            success: function(data) {
                labOrder.populate(data);
                if (successCb) {
                    successCb(labOrder);
                }
            }
        });
    }

    return {

        init: function(spec) {
            onHoldMgr = spec.onHoldMgr;
            orderForms = spec.orderForms;
            navtriggers = spec.navtriggers;
        },

        // Showing order forms
        showOrderForm: showOrderForm,
        reOrderItem: reOrderItem,
        showReferralOrderForm: showReferralOrderForm,
        showLabOrderForm: showLabOrderForm,
        showImagingOrderForm: showImagingOrderForm,
        showCardiacOrderForm: showCardiacOrderForm,
        showSleepOrderForm: showSleepOrderForm,
        showPulmonaryOrderForm: showPulmonaryOrderForm,
        showMedsOrderForm: showMedsOrderForm,
        renderOnHoldOrder: renderOnHoldOrder,

        // Specific order form functionality
        getPrintFormType: getPrintFormType,
        denyWithNewMedOrder: denyWithNewMedOrder,
        denyWithRefillMedOrder: denyWithRefillMedOrder,
        refillMedOrder: refillMedOrder,
        bulkRefillMedOrders: bulkRefillMedOrders,
        changeMedOrder: changeMedOrder,
        reOrderMedOrder: reOrderMedOrder,
        openDraftMedOrders: openDraftMedOrders,

        reOrderFromRxOrderSet: reOrderFromRxOrderSet,

        // sending lab order
        sendLabOrderToLab: sendLabOrderToLab
    };
})();
